module.exports = __webpack_public_path__ + "static/media/JS.e068a7fe.png";